export { entity_replace_all } from '../../systemCommands/entitySystem/entity_replace_all';
